import { render } from "./detalheCliente.vue?vue&type=template&id=61a754e0&scoped=true"
import script from "./detalheCliente.vue?vue&type=script&lang=js"
export * from "./detalheCliente.vue?vue&type=script&lang=js"

import "./detalheCliente.vue?vue&type=style&index=0&id=61a754e0&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a754e0"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QForm,QCard,QCardSection,QBtn,QSelect,QItem,QItemSection,QInput,QDialog,QToggle,QCardActions});qInstall(script, 'directives', {ClosePopup});
